import { IGooglePlace } from "shared/model/ICoworkGeoLocation";

import { IState } from "..";
import FirebaseDatabaseService from "../../../services/firebase/database/FirebaseDatabseService";

export const updateSelectedPlace = async (
  params: { place: IGooglePlace | string | undefined },
  state: IState
) => {
  try {
    const { place } = params;
    if (typeof place === "object") {
      try {
        await FirebaseDatabaseService.saveCachedGeoLocation(place);

        console.log(`Updated cached geo location`);
      } catch (error) {
        console.log(
          `Failed saving cached location ${JSON.stringify(place)} ${error}`
        );
      }
    } else {
      console.log(`Did not select place from list`);
    }
  } catch (error) {
    console.error(error);
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/partnersBot/PartnersBotEffects.ts